"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cyrillicCharacters = {
    "Ф": "Ф",
    "І": "І",
    "Ѡ": "Ѡ",
    "Г": "Г",
    "ҝ": "ҝ",
    "ё": "ё",
    "Х": "Х",
    "Җ": "Җ",
    "ҧ": "ҧ",
    "Ҭ": "Ҭ",
    "И": "И",
    "ї": "ї",
    "Џ": "Џ",
    "ѥ": "ѥ",
    "К": "К",
    "Һ": "Һ",
    "Л": "Л",
    "М": "М",
    "Ӌ": "Ӌ",
    "Њ": "Њ",
    "Ѣ": "Ѣ",
    "А": "А",
    "Б": "Б",
    "ҷ": "ҷ",
    "ә": "ә",
    "Ѕ": "Ѕ",
    "Є": "Є",
    "Ц": "Ц",
    "Ж": "Ж",
    "Д": "Д",
    "Ҿ": "Ҿ",
    "Ѳ": "Ѳ",
    "Е": "Е",
    "Ҩ": "Ҩ",
    "я": "я",
    "џ": "џ",
    "Ѩ": "Ѩ",
    "ҍ": "ҍ",
    "В": "В",
    "й": "й",
    "ђ": "ђ",
    "ӌ": "ӌ",
    "Ү": "Ү",
    "ң": "ң",
    "З": "З",
    "Ҟ": "Ҟ",
    "Ҥ": "Ҥ",
    "Ҷ": "Ҷ",
    "Ұ": "Ұ",
    "Щ": "Щ",
    "Ў": "Ў",
    "ю": "ю",
    "ѯ": "ѯ",
    "Н": "Н",
    "О": "О",
    "Ѫ": "Ѫ",
    "П": "П",
    "Ҙ": "Ҙ",
    "Ӕ": "Ӕ",
    "Р": "Р",
    "С": "С",
    "Т": "Т",
    "Ҽ": "Ҽ",
    "ѹ": "ѹ",
    "У": "У",
    "і": "і",
    "Ҍ": "Ҍ",
    "ғ": "ғ",
    "Й": "Й",
    "ѽ": "ѽ",
    "ҡ": "ҡ",
    "є": "є",
    "ҙ": "ҙ",
    "Ң": "Ң",
    "Ґ": "Ґ",
    "щ": "щ",
    "Ӄ": "Ӄ",
    "ж": "ж",
    "Ј": "Ј",
    "҂": "҂",
    "ҽ": "ҽ",
    "№": "№",
    "ҥ": "ҥ",
    "Ѱ": "Ѱ",
    "Ҵ": "Ҵ",
    "Ѭ": "Ѭ",
    "њ": "њ",
    "Ѥ": "Ѥ",
    "ѕ": "ѕ",
    "ӕ": "ӕ",
    "Ъ": "Ъ",
    "Ҁ": "Ҁ",
    "Ҏ": "Ҏ",
    "Ә": "Ә",
    "ҭ": "ҭ",
    "Ҕ": "Ҕ",
    "ҩ": "ҩ",
    "һ": "һ",
    "Ш": "Ш",
    "у": "у",
    "ҟ": "ҟ",
    "т": "т",
    "Ы": "Ы",
    "с": "с",
    "р": "р",
    "Ѿ": "Ѿ",
    "ѧ": "ѧ",
    "Ӈ": "Ӈ",
    "Ь": "Ь",
    "ҕ": "ҕ",
    "п": "п",
    "ӡ": "ӡ",
    "о": "о",
    "Ћ": "Ћ",
    "н": "н",
    "Ҫ": "Ҫ",
    "ұ": "ұ",
    "ѱ": "ѱ",
    "з": "з",
    "ү": "ү",
    "\u030F": "\u030F",
    "ј": "ј",
    "в": "в",
    "ҹ": "ҹ",
    "ӄ": "ӄ",
    "е": "е",
    "ѡ": "ѡ",
    "д": "д",
    "ц": "ц",
    "б": "б",
    "Ө": "Ө",
    "ґ": "ґ",
    "Љ": "Љ",
    "а": "а",
    "Ѽ": "Ѽ",
    "Ғ": "Ғ",
    "Ҹ": "Ҹ",
    "м": "м",
    "л": "л",
    "ш": "ш",
    "к": "к",
    "и": "и",
    "х": "х",
    "Ҳ": "Ҳ",
    "Ѵ": "Ѵ",
    "Ӡ": "Ӡ",
    "қ": "қ",
    "г": "г",
    "Ч": "Ч",
    "ф": "ф",
    "Ї": "Ї",
    "\u0489": "\u0489",
    "Ѯ": "Ѯ",
    "Ѻ": "Ѻ",
    "ѿ": "ѿ",
    "ҵ": "ҵ",
    "ҳ": "ҳ",
    "ў": "ў",
    "ѩ": "ѩ",
    "Я": "Я",
    "љ": "љ",
    "ө": "ө",
    "Қ": "Қ",
    "ъ": "ъ",
    "ҏ": "ҏ",
    "ҁ": "ҁ",
    "Ђ": "Ђ",
    "ѭ": "ѭ",
    "\u0488": "\u0488",
    "Ӏ": "Ӏ",
    "Ҝ": "Ҝ",
    "ѻ": "ѻ",
    "ь": "ь",
    "ҿ": "ҿ",
    "җ": "җ",
    "э": "э",
    "Ѧ": "Ѧ",
    "Ҡ": "Ҡ",
    "ы": "ы",
    "Э": "Э",
    "ӈ": "ӈ",
    "ҫ": "ҫ",
    "ч": "ч",
    "ћ": "ћ",
    "Ҧ": "Ҧ",
    "Ё": "Ё",
    "Ю": "Ю",
    "Ѹ": "Ѹ",
    "ќ": "ќ",
    "ѓ": "ѓ",
    "Ќ": "Ќ",
    "Ѓ": "Ѓ"
};
exports.isCyrillicCharacter = function (x) {
    return exports.cyrillicCharacters.hasOwnProperty(x);
};
exports.translateCharToCyrillic = function (char) {
    if (exports.isCyrillicCharacter(char))
        return exports.cyrillicCharacters[char];
    else
        return undefined;
};
//# sourceMappingURL=cyrillic.js.map